
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :fill="color"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M16.3334 8.66667H14.6667V7.00001C14.676 6.12593 14.338 5.2839 13.7269 4.65889C13.1158 4.03388 12.2816 3.677 11.4075 3.66667H11.3725C10.9371 3.65906 10.5043 3.73734 10.0991 3.89704C9.69389 4.05673 9.32412 4.29472 9.01091 4.5974C8.69771 4.90007 8.44723 5.2615 8.27378 5.66103C8.10033 6.06056 8.00731 6.49035 8.00004 6.92584V8.66667H6.33337V6.91667C6.34675 5.60977 6.87463 4.36079 7.80262 3.44045C8.7306 2.52011 9.9839 2.00257 11.2909 2.00001H11.3417C11.999 1.99879 12.65 2.12763 13.2572 2.37909C13.8645 2.63056 14.416 2.99969 14.88 3.46522C15.3439 3.93075 15.7112 4.48347 15.9607 5.09156C16.2101 5.69965 16.3368 6.35109 16.3334 7.00834V8.66667ZM5.5 10.3334H17.1667C17.8297 10.3334 18.4656 10.5968 18.9344 11.0656C19.4033 11.5344 19.6667 12.1703 19.6667 12.8334V13.7697C18.8949 13.2822 17.9804 13 17 13C14.2386 13 12 15.2386 12 18C12 19.6356 12.7854 21.0878 13.9996 22H5.5C4.83696 22 4.20107 21.7366 3.73223 21.2678C3.26339 20.799 3 20.1631 3 19.5V12.8334C3 12.1703 3.26339 11.5344 3.73223 11.0656C4.20107 10.5968 4.83696 10.3334 5.5 10.3334ZM15 18H17V22H19V18H21V16H18H15V18Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiActionflowtokenFill",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
